import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const EntityNoItemsComponent = ({isFilterEmpty = true}) => {
    const noElementsMessage = isFilterEmpty ? (
        "Não existem elementos para mostrar."
    ) : (
        <>
            Não se encontrou nenhum elemento que corresponda à sua pesquisa.
            <br />
            Por favor, tente realizar outra pesquisa ou elimine os filtros ativos.
        </>
    );

    return (
        <Grid container justifyContent="center" my={2}>
            <Typography sx={{fontStyle: "italic", textAlign: "center"}}>
                {noElementsMessage}
            </Typography>
        </Grid>
    );
};

export default EntityNoItemsComponent;
